import PreviewContainer from '../../../Carousel/Preview';
import Offer from './Offer';
import { Typography } from '@material-ui/core';
import { IUpsell } from 'interface/upsell';
import { SyntheticEvent, useState, useEffect } from 'react';
import ModalMobile from './MobileModal';
import { upsSendJudas } from 'actionCreators/judasLog';
import { hjTagging, openUpsell } from 'utils';
import { IUser } from 'interface/user';
import { connect } from 'react-redux';
import upsellFallbackImage from 'assets/img/nutror-card-upsell.png';
import Card from '../../Card';
import { v4 } from 'uuid';
import useImageFallback from 'hooks/useImageFallback';

interface IProps {
  upsell: IUpsell;
  user?: IUser;
}

const CourseCard = (props: IProps) => {
  const [showDetails, setShowDetails] = useState(false);
  const imageProps = useImageFallback(props.upsell.showcase_image ?? props.upsell.small_image, upsellFallbackImage);

  const openOffer = (event: SyntheticEvent) => {
    hjTagging('VITRINE-CLICOU-UPSELL');

    upsSendJudas({
      action: 'click',
      id: props.upsell.id,
      hash_checkout: props.upsell.content,
      viewd: 'page_courses',
      producer_id: props.upsell.producer_id,
      user_id: props.user.id,
    })();

    openUpsell(event, props.upsell, 'PRATELEIRAOFERTA', props.user);
    setShowDetails((isOpen) => (isOpen ? !isOpen : isOpen));
  };

  const toggleDetails = () => {
    setShowDetails((isOpen) => !isOpen);
  };

  useEffect(() => {
    hjTagging('VITRINE-EXIBIU-UPSELL');

    upsSendJudas({
      action: 'view',
      id: props.upsell.id,
      hash_checkout: props.upsell.content,
      viewd: 'page_courses',
      producer_id: props.upsell.producer_id,
      user_id: props.user.id,
    });
  }, [props.upsell.id, props.upsell.content, props.upsell.producer_id, props.user.id]);

  const uuid = v4();

  return (
    <>
      <PreviewContainer.Iddle onClick={() => null} onTouch={toggleDetails} id={uuid}>
        <Card onClick={() => null} title={props.upsell.title} id={props.upsell.id} {...imageProps} />
      </PreviewContainer.Iddle>
      <PreviewContainer.Active id={uuid}>
        <Card onClick={() => null} id={props.upsell.id} {...imageProps}>
          <Offer {...props} onConfirm={openOffer} toggleDetails={toggleDetails} />
          <Typography variant='body1' component='span'>
            {props.upsell.title}
          </Typography>
        </Card>
      </PreviewContainer.Active>
      <ModalMobile upsell={props.upsell} open={showDetails} onClose={toggleDetails} onConfirm={openOffer} />
    </>
  );
};

const mapStateToProps = (state: any, ownProps: any) => ({
  ...ownProps,
  user: state.user,
});

export default connect(mapStateToProps)(CourseCard);
